import PropTypes from 'prop-types';
import React from 'react';

import {useSelector} from 'react-redux';
import {i18n} from 'src/i18n';
import selectors from 'src/modules/modeloTarea/modeloTareaSelectors';
import ModeloTareaView from 'src/view/modeloTarea/view/ModeloTareaView';
import DrawerButton from 'src/view/shared/view/DrawerButton';

function ModeloTareaListItem(props) {
  const hasPermissionToRead = useSelector(selectors.selectPermissionToRead);

  const valueAsArray = () => {
    const {value} = props;

    if (!value) {
      return [];
    }

    if (Array.isArray(value)) {
      return value;
    }

    return [value];
  };

  const displayableRecord = (record) => {
    return (
      <div key={record.id}>
        <DrawerButton
          drawerId={'DrawerModeloTareaViewPage'}
          type={'chip'}
          entity={'modeloTarea'}
          tooltipTitle={i18n(record.titulo)}
          buttonTitle={i18n(record.titulo)}
          width={window.innerWidth * 0.55}
          record={record}
          component={<ModeloTareaView record={record} drawer={true} />}
        />
      </div>
    );
  };

  if (!valueAsArray().length) {
    return null;
  }

  return <>{valueAsArray().map((value) => displayableRecord(value))}</>;
}

ModeloTareaListItem.propTypes = {
  value: PropTypes.any,
};

export default ModeloTareaListItem;
